import { categoriesToGoogleTagManagerProducts } from "@/features/analytics/utils";
import type { CategoryWithSelectedProduct } from "@/features/products/models";
import { calculateTotal } from "@/features/products/utils";
import { CURRENCY } from "@/shared/models";
import type { EventPrefix, GoogleTagManagerEventDetails } from "../models";
import { EVENT_PREFIX, GOOGLE_TAG_MANAGER_EVENT } from "../models";
import {
  triggerCustomerIoPricesSelected,
  triggerGoogleTagManagerTracking,
} from "../triggers";

interface TrackPricesSelectedParams {
  selectedCategories: CategoryWithSelectedProduct[];
  userId?: string;
  eventPrefix?: EventPrefix;
}

export const trackPricesSelected = ({
  selectedCategories,
  userId,
  eventPrefix = EVENT_PREFIX.NONE,
}: TrackPricesSelectedParams) => {
  triggerGoogleTagManagerTracking<GoogleTagManagerEventDetails>({
    event: `${eventPrefix}${GOOGLE_TAG_MANAGER_EVENT.PRICES_SELECTED}`,
    ecommerce: {
      currency: CURRENCY.USD,
      value: calculateTotal(selectedCategories),
      items: categoriesToGoogleTagManagerProducts(selectedCategories),
    },
  });
  triggerCustomerIoPricesSelected({ selectedCategories, userId, eventPrefix });
};
